<template>
  <div class="__DevTools-Functions">
    <div v-for="(val, key) in functionOptions" :key="key">
      <Checkbox
        :label="key"
        :value="val"
        :disable="disabled"
        color="primary"
        @input="onChange(key, $event)"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import Checkbox from '@design-system/components/Checkbox';

export default Vue.extend({
  name: 'DevToolFunctions',
  components: { Checkbox },
  props: {
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('devTools', ['getFunctions']),

    functionOptions() {
      return this.getFunctions;
    },
  },
  methods: {
    ...mapActions('devTools', ['changeFunctionEnabled']),

    onChange(key, evt) {
      this.changeFunctionEnabled({ key: key, val: evt });
    },
  },
});
</script>
